'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDotSolidDotStrokeMeasurement, iconDotSolidDotStrokeMeasurementTag } from '@ni/nimble-components/dist/esm/icons/dot-solid-dot-stroke-measurement';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDotSolidDotStrokeMeasurement };
export { iconDotSolidDotStrokeMeasurementTag };
export const NimbleIconDotSolidDotStrokeMeasurement = wrap(IconDotSolidDotStrokeMeasurement);